import UploadNewFirmwareAction from './UploadNewFirmwareAction'
import QuickFilterFirmwareAction from './QuickFilterFirmwareAction'
import OtaFlagScreenRoute from './OtaFlagScreenRoute'
import OtaFlagScreenLink from './OtaFlagScreenLink'

const install = ( molten ) => {
  molten.addPlugin( 'Action', UploadNewFirmwareAction )
  molten.addPlugin( 'Action', QuickFilterFirmwareAction )
  molten.addPlugin( 'Route', OtaFlagScreenRoute )
  molten.addPlugin( 'Action', OtaFlagScreenLink )
}

export default {
  install
}
